import React from 'react';
import { Container } from './styles';

const Error400: React.FC = () => {
  return (
    <Container>
      <h1>400</h1>
      <p>Solicitação inválida.</p>
    </Container>
  );
};

export default Error400;
